import React, { useEffect, useState } from "react"
import { useContrato } from "../../../../../../../context/ContratoContext";
// import { Total } from "../../../../../../../services/data/dummyContratos";
// import { useModal } from "../../../../../../../hooks/ModalContext";
import { Proposta } from "../propostas";
import { useDividas } from "../../../../../../../context/DividasContext";
import { BiMinusCircle, BiPlusCircle } from 'react-icons/bi'
import { usePropostas } from "../../../../../../../context/PropostasContext";
import { Badge, Checkbox } from "flowbite-react";

interface ContratoDataProps {
  vencimento?: string;
}

interface ContratoState {
  cpf_cnpj: string, codcredor: string, contrato: string
}

export const ContratoData = ({ vencimento }: ContratoDataProps) => {
  const {
    showParcelas,
    showParcelasContrato,
    contratosData,
  } = useContrato()
  const { propostasData, getSelectedContrato, selectedContrato, getPropostas, getSelectedProposta } = usePropostas()
  const { selectedCredor, devedor } = useDividas()
  const [show, setShow] = useState(false)
  const [contrato, setContrato] = useState<ContratoState>({} as ContratoState)

  useEffect(() => {
    if (propostasData?.length > 0) {
      getPropostas({ codcredor: contrato.codcredor, cpf_cnpj: contrato.cpf_cnpj, contrato: contrato.contrato, url: selectedCredor.url_ws, vencimento })
      getSelectedProposta()
    }
  }, [vencimento])


  async function checkedContrato(cpf_cnpj: string, codcredor: string, contrato: string) {
    setContrato({ codcredor, cpf_cnpj, contrato })
    if (propostasData.length <= 0) {
      await getPropostas({ codcredor, cpf_cnpj, contrato, url: selectedCredor.url_ws, vencimento })
    }
    setShow(!show)
  }
  // console.log("Consulta", consultParamentros)
  function formatDate(date: string) {
    const [dia, mes, ano] = date?.split('/')
    return `${mes}/${dia}/${ano}`
  }
  // console.log(contratosData?.contratos.map(c => c.permiteproposta))
  return (<>
    {
      contratosData?.contratos?.length > 0 && contratosData.contratos.map(c => (
        <div key={c.numcontrato} className={`mb-4 rounded-md bg-white `} >
          <div className="flex w-full rounded-md border border-gray-400 pr-2">
            <div
              className={`mr-2 w-2 rounded-l-md ${c.permiteproposta ? " bg-green-500" : " bg-red-500"
                } `}
            ></div>
            <div className="w-full py-2">
              <div>
                <div className="my-2 flex items-center justify-between text-sm">
                  <div className="flex items-center ">
                    {
                      !c.permiteproposta && (
                        <Checkbox
                          color="green"
                          className="mr-2 bg-primary"
                          onChange={() => {
                            selectedContrato ? getSelectedContrato() : getSelectedContrato(c.numcontrato)
                          }}
                        />
                      )
                    }

                    <strong className="font-medium text-sm text-gray-600">
                      Contrato: {c.numcontrato}
                    </strong>
                  </div>
                  {
                    !c.permiteproposta && (
                      <>
                        <Badge color="success">
                          Acordado
                        </Badge>
                      </>
                    )
                  }


                  {/* <p className="font-medium text-xs text-gray-600">
                    Dias em atraso:
                    <strong className="ml-1">
                      {differenceInDays(new Date(formatDate(c.prestacoes[0].validade)), new Date(),)}
                    </strong>
                  </p> */}

                  {
                    c.permiteproposta && (
                      <button
                        className="text-lg font-bold"
                        onClick={() => {
                          checkedContrato(devedor.cpf_cnpj || '', c.codcredor, c.numcontrato)
                          showParcelasContrato(c.numcontrato);
                        }}
                      >
                        {
                          show ? <BiMinusCircle size={24} className="fill-primary" /> : <BiPlusCircle size={24} className="fill-primary" />
                        }

                      </button>
                    )
                  }



                </div>
              </div>

              <div
                className={`${!show && "hidden"
                  } `}
              >
                <>
                  {/* <TabelaParcelasData /> */}
                  {
                    propostasData && propostasData.length > 0 && propostasData.map(proposta => (
                      <Proposta proposta={proposta} contrato={c.numcontrato} />
                    ))

                  }
                </>

              </div>
            </div>
          </div>
        </div>
      )

      )
    }
  </>)
}